module.exports = __webpack_public_path__ + "static/images/callout_2.ddf7676f8a6b24214692e8e9f098daea.jpg";